import { array, objectOf } from 'prop-types';
import React, { useEffect, useState } from 'react';

import CommonImage from '@components/CommonImage';

import ProductModal from '@features/trend-research/components/common/ProductModal';
import {
	capitalizeFirstLetter,
	getDateAgo,
	trackMixPanelStyleEvent
} from '@features/trend-research/utils/utils';
import AddMoodBoard from '@features/trend-research/components/moodboard/addMoodboard';
import Tags from '@features/trend-research/components/common/Tags';

const Product = ({ allProducts }) => {
	const [showModal, setShowModal] = useState(false);
	const [isAddToMoodBoard, setIsAddToMoodBoard] = useState(false);
	const [isOpenMoodBoardModal, setIsOpenMoodBoardModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [selectedSource, setSelectedSource] = useState('');
	const selectedItem = JSON.parse(sessionStorage.getItem('selectedItem')) || {};
	useEffect(() => {
		if (selectedItem) {
			setSelectedSource(selectedItem?.source);
		}
	}, [selectedItem]);

	const showProductModal = (product) => {
		setShowModal(true);
		setSelectedProduct(product);
	};

	const onClose = () => {
		setShowModal(false);
		setSelectedProduct(null);
	};

	const handleMoodboardClick = async (product) => {
		trackMixPanelStyleEvent(product, selectedSource, 'TRENDS_ADD_TO_MOODBOARD');
		setIsAddToMoodBoard(true);
		setIsOpenMoodBoardModal(true);
		setSelectedProduct(product);
	};

	const renderInfluencerInfo = (product) => {
		return (
			<div
				className="instram-button d-flex align-items-center justify-content-center cursor-pointer"
				onClick={() => window.open(product?.postUrl, '_blank')}
			>
				<CommonImage
					className="inst-img"
					src="/icons/arrow_forward_dark.svg"
					width={16}
					height={16}
					alt="forward_dark"
				/>
				<img
					className="avatar mx-2"
					src={product?.userProfilePicUrl || `${process.env.PUBLIC_URL}/images/profile_avatar.png`}
					alt="profile_avatar"
					width={18}
					height={18}
					loading="lazy"
				/>
				<p className="radius weight-500 gray_dark_01">{product?.userName}</p>
			</div>
		);
	};

	const renderBrandLogo = (product) => {
		return (
			<div className="brand-logo">
				{product?.brandLogoDocResponse?.docUrl && (
					<CommonImage
						src={product?.brandLogoDocResponse?.docUrl}
						alt="logo"
						loading="lazy"
						isStatic={false}
					/>
				)}
			</div>
		);
	};

	return (
		<div className="all-products-item">
			{isOpenMoodBoardModal && (
				<AddMoodBoard
					isAddToMoodBoard={isAddToMoodBoard}
					setIsAddToMoodBoard={setIsAddToMoodBoard}
					isOpenMoodBoardModal={isOpenMoodBoardModal}
					setIsOpenMoodBoardModal={setIsOpenMoodBoardModal}
					selectedProduct={selectedProduct}
					source={selectedSource}
				/>
			)}

			{allProducts &&
				allProducts?.length > 0 &&
				allProducts?.map((product) => (
					<div
						key={product?.id}
						className="single-design-card trend-product-card"
						onClick={() => showProductModal(product)}
					>
						<div className="card-top">
							<img
								src={
									product?.imageUrl?.startsWith('https:')
										? product?.imageUrl
										: `${process.env.PUBLIC_URL}/images/trend/demo.jpg`
								}
								alt="card-image"
								loading="lazy"
							/>
							{product?.isBestseller && <Tags label="Bestseller" className="yellow-3" />}
							{!product?.isBestseller && product?.isNewArrival && (
								<Tags label="New" className="blue-3" />
							)}
							<div className="card-overly">
								<div className="logo-and-fab d-flex justify-content-between">
									{selectedSource === 'Brand' && renderBrandLogo(product)}
									{selectedSource === 'Instagram' && renderInfluencerInfo(product)}
									<div className="custom-chekbox" onClick={(e) => e.stopPropagation()}>
										<div className="form-group d-flex">
											{/* {selectedMoodboard?.id !== id && ( */}
											<img
												src={`${process.env.PUBLIC_URL}/icons/not-favorite.svg`}
												alt="not-favourite"
												className="add-to-favorite"
												onClick={() => handleMoodboardClick(product)}
											/>
											{/* )}  */}
											{/* {addToMoodBoard && selectedMoodboard.id === product?.id && (
												<img
													src={`${process.env.PUBLIC_URL}/icons/favorite.svg`}
													alt="favourite"
													className="add-to-favorite"
													//onClick={handleMoodboardClick}
												/>
											)} */}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="card-content">
							<p className="design-title semibold-14">
								{/* <CustomTooltip
									text={`${capitalizeFirstLetter(product.name)}`}
									position={POSITIONS.BOTTOM}
									arrowCenter={true}
									className="custom-tooltip"
								> */}
								{capitalizeFirstLetter(`${product?.name}`)}
								{/* </CustomTooltip> */}
							</p>
							{selectedSource === 'Brand' && (
								<ul className="common-list-component mt-1">
									<li>${product?.price}</li>
									<li>{product?.brandName}</li>
									{product?.lastDownloadDate && (
										<li>{getDateAgo(product.lastDownloadDate)}</li>
									)}
								</ul>
							)}
						</div>
					</div>
				))}

			{showModal && selectedProduct && (
				<ProductModal onClose={onClose} id={selectedProduct?.id} typeOfSource={selectedSource} />
			)}
		</div>
	);
};

Product.propTypes = {
	allProducts: objectOf(array)
};

export default Product;
